import React from 'react';

import { useStyles } from './TerminationPreviewField.styles';
import { TerminationPreviewFieldProps } from './TerminationPreviewField.interfaces';

export default function TerminationPreviewField(
  props: TerminationPreviewFieldProps
) {
  const classes = useStyles(props)();

  const { value, label, width = 250 } = props;

  return (
    <div className={classes.input}>
      <div className={classes.inputRow}>{value}</div>
      <svg
        width={`${width}px`}
        height="4px"
        viewBox={`0 0 ${width} 4`}
        aria-hidden="true"
        focusable="false"
      >
        <line
          x1="0"
          x2={width}
          y1="2"
          y2="2"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="1, 4"
        />
      </svg>
      {label && <div className={classes.inputLabel}>({label})</div>}
    </div>
  );
}
